import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import PagePanel from "app/components/PagePanel";
import { useSelector } from "react-redux";
import { RootState } from "typedefs";
import SpaceModel from "app/models/SpaceModel";
import { useActions } from "app/utils/hooks";
import {
  fetchSegmentById,
  editSegment,
  clearSegments,
} from "app/actions/segments";
import { fetchSpaces, clearSpace } from "app/actions/space";
import Button from "app/components/Button/ButtonVariant";
import SegmentsLayout from "app/components/Layouts/SegmentsLayout";
import { route } from "app/utils/router";

interface Props {
  resourceId: string;
}

const ManageSpaces = ({ resourceId }: Props) => {
  const segmentActions = useActions({
    fetchSpaces,
    clearSpace,
    fetchSegmentById,
    clearSegments,
    editSegment,
  });

  const options = {
    include: ["segment_names"],
  };

  useEffect(() => {
    if (resourceId) {
      segmentActions.fetchSegmentById(resourceId);
      segmentActions.fetchSpaces({ options, type: "athlete" });
    }

    return () => {
      segmentActions.clearSegments();
      segmentActions.clearSpace();
    };
  }, [resourceId]);

  const { segmentsData, segmentsPending } = useSelector(
    (state: RootState) => state.segments,
  );
  const spaceData = useSelector((state: RootState) => state.space.data);

  const [selectedSpaceIds, setSelectedSpaceIds] = useState<string[]>(null);

  useEffect(() => {
    if (segmentsData) {
      setSelectedSpaceIds((segmentsData && segmentsData.spaceIds) || []);
    }
  }, [segmentsData]);

  const cancelUrl = resourceId ? `/lists/${resourceId}/spaces` : "/lists/";

  const updateHandler = () => {
    segmentActions
      .editSegment(resourceId, {
        ...segmentsData,
        spaceIds: selectedSpaceIds,
      })
      // .then(() => (window.location.pathname = cancelUrl));
      .then(() => route(cancelUrl));
  };

  const checkHandler = (spaceId: string) => {
    if (selectedSpaceIds && selectedSpaceIds.includes(spaceId)) {
      setSelectedSpaceIds((prevSelectedSpaceIds) =>
        prevSelectedSpaceIds.filter((id) => id !== spaceId),
      );
    } else {
      setSelectedSpaceIds((prevSelectedSpaceIds) => [
        ...prevSelectedSpaceIds,
        spaceId,
      ]);
    }
  };

  const selectAllHandler = () => {
    const allSpaceIds = spaceData.map((space) => space.id);
    setSelectedSpaceIds(allSpaceIds);
  };

  return (
    <SegmentsLayout
      isLoading={segmentsPending}
      loaderChild={<h3 className="well_nothing">Loading...</h3>}
      displayNoResult={!segmentsData}
      noResultChild={<h3>No Spaces to select</h3>}
    >
      <div className={styles.container}>
        <PagePanel
          title={`Select ${segmentsData && segmentsData.name}'s Spaces`}
        >
          <ol className={styles.breadcrumb_wrapper}>
            <li>
              <a href="/lists">List</a>
            </li>{" "}
            /{" "}
            <li>
              <a href={cancelUrl}>{segmentsData && segmentsData.name}</a>
            </li>{" "}
            / <li>Spaces</li>
          </ol>
        </PagePanel>

        <div className={styles.table_wrapper}>
          <table className="segment_spaces table">
            <tbody>
              <tr>
                <th className="segment-title">
                  <span>Space</span>
                </th>

                <th className="segment-title">Already in other lists</th>
              </tr>
              {spaceData &&
                spaceData.map((space: SpaceModel) => {
                  return (
                    <tr
                      key={space.id}
                      ng-repeat="space in spaces | orderBy:'athleteName'"
                    >
                      <td>
                        <label className="checkbox-list">
                          <input
                            name={`space_${space.id}`}
                            onChange={() => checkHandler(space.id)}
                            checked={
                              selectedSpaceIds &&
                              selectedSpaceIds.includes(space.id)
                            }
                            type="checkbox"
                          />
                          {space.athleteName} &nbsp; {space.sport}
                        </label>
                      </td>

                      <td className="other-segments-label">
                        {space.segmentNames &&
                          space.segmentNames
                            .filter(
                              (segmentName: string[]) =>
                                segmentName !== segmentsData &&
                                segmentsData.name,
                            )
                            .join(", ")}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <div className={styles.buttons_wrapper}>
            <Button
              title="Select All"
              buttonType="primary"
              onClickFunc={selectAllHandler}
            />
            <Button
              title="Update"
              buttonType="primary"
              onClickFunc={updateHandler}
            />
            <a href={cancelUrl}>
              <Button title="Cancel" buttonType="secondary-outline" />
            </a>
          </div>
        </div>
      </div>
    </SegmentsLayout>
  );
};

export default ManageSpaces;
